import React,{useContext, useState, useRef, useEffect} from 'react'
import { IoAttach, IoSend } from 'react-icons/io5'
import {UserContext} from "./UserContext.jsx";
import {uniqBy} from "lodash";
import axios from "axios";
import './Chat.css'

const Chats = () => {
  const [ws,setWs] = useState(null);
  const [onlinePeople,setOnlinePeople] = useState({});
//   const [offlinePeople,setOfflinePeople] = useState({});
  const [selectedUserId,setSelectedUserId] = useState(null);
  const [newMessageText,setNewMessageText] = useState('');
  const [messages,setMessages] = useState([]);
  const {username,id,setId,setUsername} = useContext(UserContext);
  const divUnderMessages = useRef();

    useEffect(() => {
        connectToWs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUserId]);

    useEffect(() => {
        const div = divUnderMessages.current;
        if (div) {
          div.scrollIntoView({behavior:'smooth', block:'end'});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messages]);

    const connectToWs = () => {
        const ws = new WebSocket('ws://localhost:5000');
        setWs(ws);
        ws.addEventListener('message', handleMessage);
        ws.addEventListener('close', () => {
          setTimeout(() => {
            connectToWs();
          }, 1000);
        });
    }

    const showOnlinePeople = (peopleArray) => {
        const people = {};
        peopleArray.forEach(({userId,username}) => {
          people[userId] = username;
        });
        setOnlinePeople(people);
    }

    const handleMessage = (ev) => {
        const messageData = JSON.parse(ev.data);
        if ('online' in messageData) {
          showOnlinePeople(messageData.online);
        } else if ('text' in messageData) {
          if (messageData.sender === selectedUserId) {
            setMessages(prev => ([...prev, {...messageData}]));
          }
        }
    }

    const handleTextChange = (e) =>{
        setNewMessageText(e.target.value)
    }

    const sendMessage = (ev, file = null) => {
        if (ev) ev.preventDefault();
        ws.send(JSON.stringify({
          recipient: selectedUserId,
          text: newMessageText,
          file,
        }));
        if (file) {
          axios.get('/messages/'+selectedUserId).then(res => {
            setMessages(res.data);
          });
        } else {
          setNewMessageText('');
          setMessages(prev => ([...prev,{
            text: newMessageText,
            sender: id,
            recipient: selectedUserId,
            _id: Date.now(),
          }]));
        }
      }

    function sendFile(ev) {
        const reader = new FileReader();
        reader.readAsDataURL(ev.target.files[0]);
        reader.onload = () => {
          sendMessage(null, {
            name: ev.target.files[0].name,
            data: reader.result,
          });
        };
    }

    useEffect(() => {
        if (selectedUserId) {
          axios.get('/messages/'+selectedUserId).then(res => {
            setMessages(res.data);
          });
        }
    }, [selectedUserId]);
    
    const onlinePeopleExclOurUser = {...onlinePeople};
    delete onlinePeopleExclOurUser[id];
    
    const messagesWithoutDupes = uniqBy(messages, '_id');

  return (
    <form className='chat-mn-container' onSubmit={sendMessage}>
        <div className='main-chat-container'>
        {/* {!!selectedUserId && ( */}
              <div className="sub-main-chat-container">
                {messagesWithoutDupes.map(message => (
                  <div key={message._id} className={(message.sender === id ? 'float-text-right': 'float-text-left')}>
                    <div className={"mains-chat" +(message.sender === id ? 'mains-chat-sender':'mains-chat-others')}>
                      {message.text}
                      {message.file && (
                        <div className="">
                          <a target="_blank" href={axios.defaults.baseURL + '/uploads/' + message.file} rel="noreferrer">
                            {message.file}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <div ref={divUnderMessages}></div>
              </div>
          {/* )} */}
        </div>
        <div className='chat-input-field'>
            <textarea type='text' id='chat-text-area' placeholder='Message' onChange={handleTextChange} value={newMessageText}/>
            <IoAttach id='chat-attachment-icon'/>
            <button type='submit'>
                <IoSend id='chat-send-icon'/>
            </button>
        </div>
    </form>
  )
}

export default Chats